import PropTypes from 'prop-types';
import React from 'react';

import { formatAmount } from '../../utils/helpers';

const Price = ({ currency, price }) => {
	const value = formatAmount(price, {
		currency,
	});

	return <>{value}</>;
};

Price.propTypes = {
	currency: PropTypes.string,
	price: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default Price;
